<template>
  <div>
    <div class="invoices">
      <div class="w3-container w3-margin-bottom">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Subscriptions</h2>
            </header>
          </div>
          <div>
            <router-link to="/addSubscription" class="w3-button w3-green w3-small w3-right vmiddle">
              <i class="fas fa-plus" style="margin-right:8px;"></i>New Subscription
            </router-link>
          </div>
        </div>

        <!-- Subs Totals -->
        <div class="totals">
          <div>
            <div class="outline w3-center dark">
              <div class="w3-padding">
                <!-- <b>{{state.admin.global.subs.data.length}}</b> -->
                <b>0</b>
              </div>
              <footer class="w3-orange">Unpaid</footer>
            </div>
          </div>
          <div>
            <div class="outline w3-center dark">
              <div class="w3-padding">
                <!-- <b>{{state.admin.global.subs.data.length}}</b> -->
                <b>0</b>
              </div>
              <footer class="w3-red">Overdue</footer>
            </div>
          </div>
          <div>
            <div class="outline w3-center dark">
              <div class="w3-padding">
                <!-- <b>{{state.admin.global.subs.data.length}}</b> -->
                <b>{{state.admin.global.subs.data.length}}</b>
              </div>
              <footer class="w3-green">Paid</footer>
            </div>
          </div>
          <div>
            <div class="outline w3-center dark">
              <div class="w3-padding">
                <b>{{state.admin.global.subs.data.length}}</b>
              </div>
              <footer class="w3-blue">Total</footer>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="w3-row">
          <div class="w3-col">
            <div class="outline w3-margin-top">
              <div class="w3-row w3-margin-bottom">
                <template v-if="state.admin.global.subs.data.length > 0">
                  <header class="w3-bar w3-white outline">
                    <h5 class="w3-bar-item" style="margin:5px 0;">All Subscriptions</h5>
                  </header>
                  <table class="w3-table w3-bordered subscriptionResults w3-white" :class="{'w3-responsive' : state.width < 1025}">
                    <tr class="headingRow w3-light-grey">
                      <td style="min-width:80px; width:200px;">Customer</td>
                      <td style="min-width:250px;">Items</td>
                      <td class="w3-center" style="min-width:90px; width:90px;">Period</td>
                      <td class="w3-center" style="min-width:70px; width:90px;">Total</td>
                      <td class="w3-center" style="min-width:80px; width:80px;">Status</td>
                      <td class="w3-center" style="min-width:150px; width:150px;">Actions</td>
                    </tr>
                    <tr v-for="(sub, index) in state.admin.global.subs.data" :key="index">
                      <td style="white-space: nowrap">{{customerName(sub.customer)}}</td>
                      <td>
                        <span v-for="(item, key, i) in sub.items.data" :key="i" >
                          {{item.plan.nickname | capitalize}} <span v-if="sub.metadata[item.plan.id]">({{sub.metadata[item.plan.id]}})</span><span v-if="key < Object.keys(sub.items.data).length - 1">, </span>
                        </span>
                      </td>
                      <td class="w3-center">{{sub.current_period_start | date}}<br/><span v-if="!sub.cancel_at_period_end">{{sub.current_period_end | date}}</span><span v-else>Ongoing</span></td>
                      <td class="w3-center">{{sub.total / 100 | currency}}</td>
                      <td class="w3-center" :class="{'w3-text-green': (sub.status === 'paid'),'w3-text-red': (sub.status === 'overdue'),'w3-text-orange': (sub.status === 'open'),'w3-text-light-grey': (sub.status === 'draft')}">{{sub.status | capitalize}}</td>
                      <td class="w3-center">
                        <div class="w3-bar">
                          <button @click.prevent="deleteSub(sub.id)" class="w3-button w3-red w3-small">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </table>
                </template>
                <template v-else>
                  <div class="w3-container">
                    <p>No Subscriptions Yet</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore';

export default {
  name: "Subscriptions",
  data() {
    return {
      state: dataStore.state,
      addScreen: false
    };
  },
  created() {
    dataStore.getAdminGlobalData()
  },
  methods: {
    deleteSub(id) {
      if (confirm('Really delete this subscription?')) {
        const sub = {subid: id}
        dataStore.cancelSubscription(sub).then(result => {
          if (result.data.code === 'success') {
            dataStore.getAdminGlobalData()
          } else {
            console.log(result)
          }
        })
      }
    },
    customerName(custid) {
      for (let custy of this.state.admin.global.clients.list) {
        if (custy.stripeid == custid) {
          return custy.name
        }
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions.vue